import type { AppPrimitiveTokens } from './primitive.model';

export const primitive: AppPrimitiveTokens = {
	borderRadius: {
		none: '0',
		xs: '2px',
		sm: '4px',
		md: '6px',
		lg: '8px',
		xl: '12px',
	},
	green: {
		50: '#f4fbf7',
		100: '#e3f8ea',
		200: '#baedcd',
		300: '#6bd893',
		400: '#4ed17e',
		500: '#22c55e',
		600: '#1fb356',
		700: '#188c43',
		800: '#136c34',
		900: '#0e5327',
		950: '#072712',
	},
	red: {
		50: '#fdecec',
		100: '#fac5c5',
		200: '#f8a9a9',
		300: '#f48282',
		400: '#f26969',
		500: '#ef4444',
		600: '#d93e3e',
		700: '#aa3030',
		800: '#832525',
		900: '#641d1d',
		950: '#3b1111',
	},
	orange: {
		50: '#fdf0e6',
		100: '#f8d0b2',
		200: '#f5b98d',
		300: '#f1995a',
		400: '#ee8539',
		500: '#ea6708',
		600: '#d55e07',
		700: '#a64906',
		800: '#813904',
		900: '#622b03',
		950: '#311602',
	},
	yellow: {
		50: '#fdf7e6',
		100: '#f8e7b2',
		200: '#f5dc8d',
		300: '#f1cc5a',
		400: '#eec239',
		500: '#eab308',
		600: '#d5a307',
		700: '#a67f06',
		800: '#816204',
		900: '#624b03',
		950: '#312602',
	},
	blue: {
		50: '#eff5fd',
		100: '#c1d3eb',
		200: '#83a6d7',
		300: '#467ac4',
		400: '#2d548b',
		500: '#192f4e',
		600: '#14253e',
		700: '#0f1c2e',
		800: '#0a131f',
		900: '#05090f',
		950: '#020508',
	},
	purple: {
		50: '#f3efff',
		100: '#e6defb',
		200: '#cdbdf6',
		300: '#a98fee',
		400: '#8a66e6',
		500: '#6d40dc',
		600: '#5a2fc9',
		700: '#4a22b0',
		800: '#3a1a8a',
		900: '#2c1468',
		950: '#1b0c40',
	},
	gray: {
		50: '#F5F6F8',
		100: '#E4E7EC',
		200: '#b2bbc7',
		300: '#8c99ab',
		400: '#67788e',
		500: '#A8A8A8',
		600: '#8A8A8A',
		700: '#2d343e',
		800: '#1e2329',
		900: '#0f1115',
		950: '#060709',
		960: '#686A74',
	},
	neutral: {
		50: '#fcfcfc',
		100: '#f5f5f5',
		200: '#f2f2f2',
		300: '#ebebeb',
		400: '#e3e3e3',
		500: '#dcdcdc',
		600: '#b0b0b0',
		700: '#858585',
		800: '#595959',
		900: '#2b2b2b',
		950: '#171717',
		960: '#09111D',
		white: '#ffffff',
	},
};
